module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.3dc12e16.jpg";